import Step from '../components/Step'
import '../styles/landing.css'

const steps = [
  {
    number: 1,
    title: "Entra a la plataforma",
    description: "Disponible ahora para navegador web, Android (APK y PWA) e iOS. Instalación rápida y segura."
  },
  {
    number: 2,
    title: "Crea tu perfil",
    description: "Regístrate en segundos con tu cuenta de Google o el e-mail de tu preferencia, agrega tu área de interés y listo."
  },
  {
    number: 3,
    title: "Elige tu plan de estudio",
    description: "Simuladores gratuitos o la suscripción premium de Vortex EXANI-II para acceso completo a todas las herramientas avanzadas."
  },
  {
    number: 4,
    title: "Disfruta el proceso",
    description: "Haz que tu preparación al EXANI-II para universidades públicas y autónomas sea diferente a todos los demás. Disciplina, constancia y Vortex serán la llave para tus metas."
  }
]

export default function HowItWorks() {
  return (
    <section id="howitworks" className="section section-alt">
      <div className="container">
        <div className="text-center mb-2xl">
          <h2>¿Cómo funciona?</h2>
          <p className="section-subtitle">
            En solo 4 pasos y estarás en camino hacia tu próximo Ascenso.
          </p>
        </div>

        <div className="grid grid-4">
          {steps.map((step, index) => (
            <Step
              key={index}
              number={step.number}
              title={step.title}
              description={step.description}
            />
          ))}
        </div>

        <div className="howitworks-banner">
          <h3>¿Qué es Vortex?</h3>
          <p>
            Vortex es una aplicación para dispositivos Android, la cual te ofrece una variedad de herramientas de apoyo para tu estudio. No te prometemos que ascenderás, sin embargo te ofrecemos cuestionarios con más de 1200 preguntas, audios de Conocimientos Marineros, Legislación Naval e Historia y Cultura Naval, un Quizz que funciona como un simulador de examen, además de 4 nuevas herramientas que funcionan con Inteligencia Artificial, como son:
          </p>
          
          <p className="highlight-item">
            <strong>VORTEX AI:</strong> Asistente digital para tus consultas en temas especializados del ámbito naval y muchas tareas más.
          </p>
          
          <p className="highlight-item">
            <strong>VORTEX QUIZZ:</strong> Herramienta que utiliza tu información para generarte cuestionarios hechos a tu medida. No importa la rama, Vortex te creará tus preguntas y podrás integrarlas en la aplicación, además de poder subir tus propios cuestionarios.
          </p>
          
          <p className="highlight-item">
            <strong>VORTEX AUDIO:</strong> Herramienta que utiliza motores TTS de Google para convertir tus textos en audios, convierte tu información a voces naturales y estudia mientras escuchas.
          </p>
          
          <p className="highlight-item">
            <strong>VORTEX DOCS:</strong> Herramienta que utiliza tus documentos txt, pdf y .docx para realizar extracción de tu información, extrae el texto de tus archivos y genera tus propios resúmenes.
          </p>
          
          <p className="highlight-text">
            COMBINA LAS HERHERRAMIENTAS: CREA TUS RESÚMENES CON VORTEX DOCS Y CONVIÉRTELOS EN AUDIO CON VORTEX AUDIO, EXTRAE TU INFORMACIÓN Y CON VORTEX QUIZZ CREA CUESTIONARIOS A PARTIR DEL TEXTO COMPLETO O DEL RESUMEN QUE TE GENERÓ. EL LÍMITE LO PONES TÚ.
          </p>

          <div className="section-cta">
            <h3>¿Tienes preguntas?</h3>
            <p>
              Nuestro equipo está aquí para ayudarte a comenzar tu viaje hacia el éxito profesional.
            </p>
            <a href="#contact" className="btn btn-secondary">
              Contactar soporte
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}